<template>
  <div class="contentright" v-if="activeIndex == 0 || activeIndex == 4">
    <div class="communActivity philosopher" v-if="activitylist.length != 0">
      <strong>{{$t('global.活动')}}</strong>
      <span @click="changeIndex(4)">
        {{$t('global.查看全部')}}
        <img src="/static/home/images/morenext.jpg" />
      </span>
    </div>
    <div class="deliberate activitylist" v-if="activitylist.length != 0">
      <ul>
        <li v-for="activity in activitylist" :key="activity.id">
          <div class="left">
            <img :src="activity.activityThumb | imageUrl('',190,252)" alt />
            <span>{{activity.status}}</span>
          </div>
          <div class="right">
            <h4>{{activity.activityTitle}}</h4>
            <span>{{activity.holdStartTime|formatDate('YYYY.MM.DD') }} - {{activity.holdEndTime|formatDate('YYYY.MM.DD')}}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="communActivity philosopher" v-if="questionList.length != 0">
      <strong>{{$t('global.热门文章')}}</strong>
      <span @click="changeIndex(4)">
        {{$t('global.查看全部')}}
        <img src="/static/home/images/morenext.jpg" />
      </span>
    </div>
    <div class="deliberate" v-if="questionList.length != 0">
      <ul>
        <li v-for="mylist in questionList" :key="mylist.createTime">
          <p
            @click="toLinks(mylist)"
            class="titles"
            style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;line-clamp: 2;"
          >{{mylist.title}}</p>
          <div class="userinfor">
            <img @click="myCenter(mylist)" :src="mylist.avatar | imageUrl('/static/profile_img_default.png',40,40)" />
            <span @click="myCenter(mylist)">{{mylist.nickName}}</span>
            <div class="peopleNums">
              {{mylist.answerCount}}
              <span>{{$t('global.回复')}}</span>
            </div>
            <a>{{timeStamp(mylist.createTime)}}</a>
          </div>
        </li>
      </ul>
    </div>

    <div class="communActivity philosopher" v-if="philosopherman.length > 0">
      <strong>{{$t('global.创作者')}}</strong>
      <span @click="changeIndex(3,1)" v-show="isMore">
        {{$t('global.查看全部')}}
        <img src="/static/home/images/morenext.jpg" />
      </span>
    </div>
    <div class="philosoman" v-if="philosopherman.length > 0">
      <ul>
        <li v-for="item in philosopherman" :key="item.nickName">
          <router-link target="_blank" :to="'/peopleCenter/'+item.userId">
            <img :src="item.avatar | imageUrl('/static/profile_img_default.png', 140,140)" />
            <div class="dsname">
              <h4>{{item.nickName}}</h4>
              <button
                :key="1"
                class="attenbtn following"
                v-if="item.isFollow==1"
                @click.stop.prevent="Follow(item)"
                @mouseenter="toggleTitle1"
                @mouseleave="toggleTitle2"
              >{{$t('global.已关注')}}</button>
              <button
                :key="2"
                class="attenbtn"
                v-else
                @click.stop.prevent="Follow(item)"
              >+ {{$t('global.关注')}}</button>
            </div>
            <p class="signatureuser" v-html="item.introduce"></p>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="communActivity philosopher" v-if="aboutCommunity.length > 0">
      <strong>{{$t('global.相关频道')}}</strong>
    </div>
    <div class="aboutCommunity" v-if="aboutCommunity.length > 0">
      <ul>
        <li v-for="item in aboutCommunity" :key="item.relevantTopicId">
          <router-link target="_blank" :to="'/subjectdetail/'+item.relevantTopicId">
            <img :src="item.relevantTopicThumb | imageUrl('', 130, 130)" />
            <p>{{item.relevantTopicTitle}}</p>
            <div class="learning">
              <span>{{$t('global.成员')}}</span>
              <b>{{item.memberCount}}</b>
              <span>{{$t('global.视频')}}</span>
              <b>{{item.videoCount}}</b>
            </div>
          </router-link>
        </li>
      </ul>
    </div>

    <!--发布弹窗-->
    <div v-if="publish" class="fixpublish"></div>
    <div v-if="publish" class="publishbtnbox">
      <p class="changepublish">{{$t('global.选择发布类型')}}</p>
      <div class="article" :class="{active:isActive == 0}" @click="changeActive(0)">
        <span>{{$t('global.文章')}}</span>
        {{$t('global.发表见解')}}，{{$t('global.分享知识')}}
      </div>
      <div class="question" :class="{active:isActive == 1}" @click="changeActive(1)">
        <span>{{$t('global.问答')}}</span>
        {{$t('global.精确描述问题')}}，{{$t('global.得到解答')}}
      </div>
      <a class="cancel" @click="closepopus">{{$t('global.取消')}}</a>
      <a href="javascript:;" @click="hiddeny">{{$t('global.确定')}}</a>
      <img @click="closepopus" src="/static/closepopus.png" />
    </div>

    <!--$t('global.登陆弹窗')-->
    <div v-if="logining" class="fixlogining"></div>
    <div v-if="logining" class="loginingbox">
      <p class="headlogo">
        <img src="/static/manalogo1.png" />
      </p>
      <div class="loginform">
        <input
          class="userinfor"
          v-model="form.email"
          type="text"
          :placeholder="`${$t('global.输入账号')}/${$t('global.邮箱')}`"
        />
        <input
          class="userinfor"
          v-model="form.password"
          type="password"
          :placeholder="$t('global.输入密码')"
        />
        <a class="loginbtn" @click="login">{{$t('global.登录')}}</a>
        <router-link to="/reg" class="goregister">{{$t('global.没有账号')}}？{{$t('global.点击注册')}}</router-link>
        <div class="otherlogin">
          <span>{{$t('global.第三方登陆')}}</span>
        </div>
        <div class="login-ways">
          <span class="login-way login-way-qq" @click="qqLogin"></span>
          <span class="login-way login-way-wechat" @click="wechatLogin"></span>
          <span class="login-way login-way-weibo" @click="weiboLogin"></span>
        </div>
        <img class="closepopus" @click="closepopus" src="/static/closepopus.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  name: "SubjectDetailRight",
  components: {},
  props: {
    activeIndex: {
      type: Number
    },
    topicId: {
      type: String
    },
    isMore: {
      type: Boolean
    },
    isCreate: {
      type: Boolean
    },
    topicName: {
      type: String
    }
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      activitylist: [],
      aboutCommunity: [],
      philosopherman: [],
      directitemList: [],
      questionList: [],
      publish: false,
      isActive: 0,
      logining: false
    };
  },
  created() {
    this.getPhilosopherMan();
    this.getAboutCommunity();
    this.getDirectitemList();
    this.getQuestionList();
    this.getHostList();
    // this.deleteQuestion();
  },
  computed: {
    directitemListSlice: function() {
      return this.directitemList.slice(0, 8);
    }
  },
  methods: {
    toggleTitle1() {
      event.target.innerHTML = this.$t("global.取消关注");
      event.target.classList.add("focus");
    },
    toggleTitle2() {
      event.target.innerHTML = this.$t("global.已关注");
      event.target.classList.remove("focus");
    },
    getHostList() {
      this.$http
        .get(
          "/api/topic/activity/list?topicId=" +
            this.$query.id +
            "&orderBy=0&pageIndex=1&pageSize=3"
        )
        .then(response => {
          this.activitylist = response.data.list;
        });
    },
    myCenter(item) {
      let routerData = this.$router.resolve({
        path: `/peopleCenter/${item.userId}`
      });
      window.open(routerData.href, "_blank");
    },
    toLinks(item) {
      let routerTitle = this.$router.resolve({
        path: `/discussDetail?id=${item.id}&author=${item.userId}&activeIndex=4&topicId=${this.topicId}&topicName=${this.topicName}`
      });
      window.open(routerTitle.href, "_blank");
    },
    hiddeny() {
      document.documentElement.style.overflowY = "scroll";
      this.$router.push({
        path: `/publishPage?topicId=${this.topicId}&typeId=${this.isActive}&topicName=${this.topicName}`
      });
    },
    qqLogin() {
      this.$http.get("/api/passport/qqLogin").then(res => {
        if (res) {
          location.href = res.data;
        }
      });
    },
    wechatLogin() {
      this.$http.get("/api/passport/wechatLogin").then(res => {
        if (res) {
          location.href = res.data;
        }
      });
    },
    weiboLogin() {
      this.$http.get("/api/passport/weiboLogin").then(res => {
        if (res) {
          location.href = res.data;
        }
      });
    },
    login() {
      if (this.form.email == null || this.form.email == "") {
        this.$message.error(this.$t("global.请输入账号"));
        return;
      }
      if (this.form.password == null || this.form.password == "") {
        this.$message.error(this.$t("global.请输入密码"));
        return;
      }
      let $this = this;
      this.$http.post("/api/passport/login", this.form).then(response => {
        if (!response || response == undefined) {
          $this.$message.error(this.$t("global.用户名或密码错误"));
          return;
        }
        localStorage.setItem("auth_token", response.data.token);
        localStorage.setItem("userId", response.data.userId);
        this.$store.dispatch("setAccountUser", {
          ...response.data,
          phone: response.data.mobile
        });
        this.$http.get("/api/u/info/get").then(res => {
          this.$store.dispatch("setNewState", {
            peopleMessage: res.data,
            isLogin: true
          });
          document.documentElement.style.overflowY = "scroll";
          $this.reload();
        });
      });
    },

    publishbtn() {
      let that = this;
      //未登陆弹登陆窗口
      if (!localStorage.getItem("auth_token")) {
        this.logining = true;
        document.documentElement.style.overflowY = "hidden";
      } else {
        this.$http
          .get("/api/u/topicquestion/getQuestionCreateQx", {
            params: { topicId: this.topicId }
          })
          .then(response => {
            if (response.data) {
              //已登陆弹发布窗口
              this.publish = true;
              document.documentElement.style.overflowY = "hidden";
            } else {
              this.$confirm(
                `${this.$t("global.非本频道成员无法提出问题")}, ${this.$t(
                  "global.是否关注此频道继续"
                )}?`,
                this.$t("global.提示"),
                {
                  confirmButtonText: this.$t("global.关注"),
                  cancelButtonText: this.$t("global.取消"),
                  type: "warning"
                }
              )
                .then(() => {
                  this.$http
                    .post("/api/u/topic/join", { topicId: this.topicId })
                    .then(function(response) {
                      that.$message({
                        message: that.$t("global.关注成功"),
                        type: "success",
                        duration: 2000
                      });
                    });
                })
                .catch(() => {});
            }
          });
      }
    },
    closepopus() {
      this.publish = false;
      this.logining = false;
      document.documentElement.style.overflowY = "scroll";
    },

    changeActive(index) {
      this.isActive = index;
    },

    changeIndex(index, childIndex) {
      this.$emit("change-index", index, childIndex);
    },
    //$t('global.达人')
    getPhilosopherMan() {
      let $this = this;
      this.$http
        .get("/api/topic/getMemberListByParms?topicId=" + this.topicId, {
          params: { orderBy: 0, roleIds: 3, pageIndex: 1, pageSize: 3 }
        })
        .then(function(response) {
          $this.philosopherman = response.data.list;
        });
    },
    //$t('global.相关频道')
    getAboutCommunity() {
      let $this = this;
      this.$http
        .get(
          "/api/topic/relevant/list?topicId=" +
            this.topicId +
            "&orderBy=0&pageIndex=1&pageSize=4"
        )
        .then(function(response) {
          $this.aboutCommunity = response.data.list;
        });
    },
    //$t('global.主持团')
    getDirectitemList() {
      let $this = this;
      this.$http
        .get(
          "/api/topic/getMemberListByParms?topicId=" +
            this.topicId +
            "&roleIds=1,2",
          { params: { orderBy: 0, pageIndex: 1, pageSize: 10 } }
        )
        .then(function(response) {
          $this.directitemList = response.data.list;
        });
    },
    Follow(item) {
      let that = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push("/login?redirecturl=" + this.$route.path);
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(function(response) {
          if (response) {
            item.isFollow = !item.isFollow;
            if (item.isFollow) {
              that.$message.success(response.message);
            } else {
              that.$message(response.message);
            }
          }
        });
    },

    getQuestionList() {
      var aa = this.selectedOrder;
      this.$http
        .get("/api/topic/findQuestionList", {
          params: {
            topicId: this.topicId,
            orderByType: 3,
            pageIndex: 1,
            pageSize: 3
          }
        })
        .then(response => {
          this.questionList = response.data.list;
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
/* contentright rightside start */
.advertising {
  position: relative;
  width: 320px;
  height: 107px;
  margin-bottom: 60px;
}

.advertising img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  cursor: pointer;
}

.contentright {
  float: left;
  width: 320px;
  margin: 25px 0 0 80px;
}

.contentright .directitem {
  position: relative;
  height: 45px;
  margin: 20px 0 60px 0;
}

.directitem li {
  float: left;
  width: 50px;
  height: 50px;
}

.directitem li img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #e2e2e2;
}

.directitem ul {
  position: relative;
  width: auto;
  z-index: 10;
  height: 50px;
}

.directitem ul li {
  position: absolute;
  top: 0;
  left: 0;
}

.directitem ul li:nth-child(1) {
  z-index: 9;
}

.directitem ul li:nth-child(2) {
  z-index: 8;
  left: 30px;
}

.directitem ul li:nth-child(3) {
  z-index: 7;
  left: 60px;
}

.directitem ul li:nth-child(4) {
  z-index: 6;
  left: 90px;
}

.directitem ul li:nth-child(5) {
  z-index: 5;
  left: 120px;
}

.directitem ul li:nth-child(6) {
  z-index: 4;
  left: 150px;
}

.directitem ul li:nth-child(7) {
  z-index: 3;
  left: 180px;
}

.directitem ul li:nth-child(8) {
  z-index: 2;
  left: 210px;
}

.directitem ul li:nth-child(9) {
  z-index: 1;
  left: 240px;
}

.directitem ul li + .morelogos {
  width: 52px;
  height: 52px;
  margin-top: -3px;
}

.philosopher {
  margin: 40px 0 20px;
}

.philosoman li {
  overflow: hidden;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid rgba(237, 236, 241, 1);
  display: flex;
  align-items: center;

  a {
    width: 100%;
  }
}

.philosoman li:last-child {
  border-bottom: none;
  margin-bottom: 46px;
}

.philosoman li img {
  float: left;
  width: 70px;
  height: 70px;
  margin-right: 10px;
  border-radius: 50%;
}

.philosoman li .dsname {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  h4 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }

  .attenbtn {
    width: 60px;
    height: 24px;
    border-radius: 2px;
    color: #2026CC;
    font-size: 12px;
    border: 1px solid #2026CC;
    background: #fff;

    &.attenbtn.following {
      border-color: #B8B8B8;
      color: #B8B8B8;

      &.focus {
        color: #999;
        border-color: #999;
      }
    }
  }
}

.signatureuser {
  height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: NunitoSans-Regular, NunitoSans;
  font-weight: 400;
  color: #999;
}

.aboutCommunity li {
  overflow: hidden;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid rgba(237, 236, 241, 1);
}

.aboutCommunity li:last-child {
  border-bottom: none;
}

.aboutCommunity li img {
  float: left;
  width: 66px;
  height: 66px;
  margin-right: 10px;
}

.aboutCommunity li p {
  float: left;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  width: 234px;
  height: 44px;
  overflow: hidden;
  line-height: 22px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.aboutCommunity li .learning {
  float: left;
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.aboutCommunity li .learning span {
  margin-right: 5px;
}

.aboutCommunity li .learning b {
  color: #999;
  margin-right: 20px;
}

.communActivity strong {
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
}

.communActivity span {
  display: inline-block;
  float: right;
  width: 60px;
  color: #999;
  font-size: 12px;
  cursor: pointer;
  line-height: 16px;
  margin-top: 5px;
}

.communActivity span img {
  float: right;
  margin-top: 4px;
}

.deliberate {
  margin-bottom: 20px;

  &.activitylist {
    ul {
      li {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: none;

        .left {
          width: 95px;
          position: relative;
          margin-right: 10px;

          img {
            width: 95px;
            height: 126px;
          }

          span {
            position: absolute;
            top: 5px;
            right: -50px;
            width: 70px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            background: #2026CC;
            color: #fff;
          }
        }

        .right {
          flex: 1;

          h4 {
            font-size: 15px;
            font-weight: 600;
            color: #0A0A0A;
          }

          span {
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
  }
}

.deliberate .titles {
  display: block;
  width: 320px;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  max-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.deliberate .userinfor {
  height: 26px;
  margin-top: 12px;
  color: #999;
  font-size: 12px;
  line-height: 20px;
}

.deliberate .userinfor img {
  float: left;
  width: 20px;
  height: 20px;
  border-radius: 13px;
  cursor: pointer;
}

.deliberate .userinfor img + span {
  float: left;
  display: inline-block;
  margin: 0 0 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.deliberate .userinfor .peopleNums {
  float: left;
  width: 65px;
  margin: 0 5px;
  font-size: 12px;
  height: 16px;
  text-align: center;
  overflow: hidden;
}

.deliberate .userinfor .peopleNums + a {
}

.deliberate ul li {
  position: relative;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(237, 236, 241, 1);
}

.deliberate ul li:last-child {
  border: none;
}

.deliberate ul li:first-child ~ li {
  margin-top: 15px;
}

/* 发布弹窗 $t('global.登陆') */
.fixpublish, .fixlogining {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
}

.publishbtnbox, .loginingbox {
  position: fixed;
  width: 428px;
  height: 356px;
  top: 50%;
  left: 50%;
  z-index: 1001;
  transform: translate(-50%, -50%);
  background-color: #fff;
}

.changepublish {
  color: #333;
  font-size: 20px;
  width: 428px;
  text-align: center;
  margin-top: 30px;
}

.publishbtnbox .article {
  width: 358px;
  height: 63px;
  color: #999;
  font-size: 14px;
  line-height: 63px;
  border-radius: 5px;
  margin: 29px auto 0;
  cursor: pointer;
  border: 1px solid rgba(221, 221, 221, 1);
}

.publishbtnbox .article span {
  font-size: 24px;
  font-weight: bold;
  margin: 0 20px;
}

.publishbtnbox .question {
  width: 358px;
  height: 63px;
  color: #999;
  font-size: 14px;
  line-height: 63px;
  border-radius: 5px;
  margin: 20px auto 0;
  cursor: pointer;
  border: 1px solid rgba(221, 221, 221, 1);
}

.publishbtnbox .question span {
  font-size: 24px;
  font-weight: bold;
  margin: 0 20px;
}

.publishbtnbox div.active {
  color: #43c0bd;
  border: 1px solid rgba(67, 192, 189, 1);
}

.publishbtnbox a {
  display: inline-block;
  float: left;
  width: 100px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 44px;
  background-color: #4a90e2;
}

.publishbtnbox a.cancel {
  margin: 44px 20px 0 104px;
  background: rgba(202, 202, 202, 1);
}

.publishbtnbox img, .loginingbox img.closepopus {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

/* loginingbox  start */
.loginingbox {
  height: 504px;
}

.loginingbox .headlogo {
  width: 130px;
  height: 34px;
  margin: 55px auto 0;
}

.loginingbox .headlogo img {
  width: 100%;
  height: 100%;
}

.loginingbox .loginform {
  padding: 50px 64px 0;
}

.loginingbox .loginform input.userinfor {
  width: 100%;
  height: 40px;
  font-size: 16px;
  margin-bottom: 30px;
  border-bottom: 1px solid #e8e8e8;
}

.loginingbox .loginbtn {
  display: block;
  width: 100%;
  height: 40px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  line-height: 40px;
  background-color: #abaaba;
}

.loginingbox .goregister {
  display: block;
  color: #999;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  margin-top: 22px;
}

.loginingbox .otherlogin {
  text-align: center;
  color: #999;
  font-size: 12px;
  margin-top: 30px;
}

.loginingbox .otherlogin span {
  display: inline-block;
  position: relative;
  width: 100px;
}

.loginingbox .otherlogin span:after {
  position: absolute;
  display: block;
  content: '';
  height: 1px;
  width: 120px;
  top: 8px;
  left: 130px;
  background-color: #e8e8e8;
}

.loginingbox .otherlogin span:before {
  position: absolute;
  display: block;
  content: '';
  height: 1px;
  width: 120px;
  top: 8px;
  right: 130px;
  background-color: #e8e8e8;
}

/* login-way */
.login-ways {
  text-align: center;
  margin-top: 30px;
}

.login-ways span {
  cursor: pointer;
}

.login-way {
  display: inline-block;
  width: 0.36rem;
  height: 0.36rem;
  margin: 0 0.275rem;
}

.lefttypes {
  position: absolute;
  color: #fff;
  top: 2px;
  left: 0;
  font-size: 12px;
  padding: 1px 7px;
  border-radius: 3px;
  background-color: #df7979;
}

.colortype {
  background-color: #4a90e2;
}

.login-way-qq {
  background: url('/static/qq.png') no-repeat center center;
  background-size: contain;
}

.login-way-wechat {
  background: url('/static/wechat.png') no-repeat center center;
  background-size: contain;
}

.login-way-weibo {
  background: url('/static/weibo.png') no-repeat center center;
  background-size: contain;
}

.loginform input::-webkit-input-placeholder {
  color: #999;
  font-size: 16px;
}

.loginform input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
  font-size: 16px;
}

.loginform input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
  font-size: 16px;
}

.loginform input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/SubjectDetailRight.vue